import { useEffect } from 'react'
import { useIntl } from 'react-intl'
import { useGetSelfcareCartQuery } from 'store/api-slice/hooks'
import { setIsErrorModalOpened } from 'store/general-slice'
import { useAppDispatch, useAppSelector } from 'store/hooks'
import { LanguageType } from 'store/steps'
import { setSelfcareCart } from '.'
import { getLanguageFromLocale } from 'helpers/i18n'

export const useSelfcareCart = (): {
    refetchSelfcareCart: () => void
    isSelfcareCartFetching: boolean
    isOrderModified: boolean
} => {
    const dispatch = useAppDispatch()
    const { locale } = useIntl()

    const { appMode, isAppAccessible } = useAppSelector(
        (state) => state.general
    )
    const { cartId, countChanges, countNewItems } = useAppSelector(
        (state) => state.selfcareCart
    )

    const language: LanguageType = getLanguageFromLocale(locale)
    const isOrderModified = countChanges + countNewItems > 0

    const {
        data: cartData,
        refetch,
        isFetching: isSelfcareCartFetching,
        error,
    } = useGetSelfcareCartQuery(
        { _locale: language },
        { skip: appMode !== 'selfcare' || !isAppAccessible }
    )

    useEffect(() => {
        if (isSelfcareCartFetching) return

        if (cartId && error) {
            dispatch(setIsErrorModalOpened(true))
        }

        if (cartData) {
            dispatch(setSelfcareCart(cartData))
        }
    }, [isSelfcareCartFetching])

    const refetchSelfcareCart = () => {
        refetch()
    }

    return {
        refetchSelfcareCart,
        isSelfcareCartFetching,
        isOrderModified,
    }
}
